import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, ElementRef, ViewChild  } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { AlertComponent } from 'src/app/common/alert/alert.component';
import { ConfirmModelComponent } from 'src/app/common/confirm-model/confirm-model.component';
import { Globals } from 'src/app/models/globals.model';
import { GlobalService } from 'src/app/services/global.service';
import { HttpService } from 'src/app/services/http.service';
import { UOMData } from 'src/assets/UOMData';
import { FormulaList } from '../kpi-models/FormulaList';
import { dataSourceModel } from '../../models/dataSource.model';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

let tagNames = [];
let prefixTag = '';

export interface FBDialogData {
  FormulaList: FormulaList[];
  UsedFor: string;
}

export interface Constant {
  constantId: string;
  value: string;
  uom: string;
  createdBy: string;
  lastModifiedBy: string;
}

@Component({
  selector: 'app-create-formula-model',
  templateUrl: './create-formula-model.component.html',
  styleUrls: ['./create-formula-model.component.scss']
})
export class CreateFormulaModelComponent implements OnInit {
  isLoader = false;
  formulaBuilderForm = new UntypedFormGroup({
    frequencyHcf: new UntypedFormControl('', [Validators.required, Validators.min(5), Validators.max(10080)]),
    siConversionIgnored: new UntypedFormControl(false),
    uomType: new UntypedFormControl('', Validators.required),
    uom: new UntypedFormControl('', Validators.required),
    formulaName: new UntypedFormControl('', Validators.required),
    formulaExpression: new UntypedFormControl('', Validators.required),
    dataSource: new UntypedFormControl('')
  });
  processNames: string[];
  existingFormulae = [];
  constants = [];
  mathFunctions = [];
  uomMap: Array<any>;
  uomTypes: string[];
  uoms: string[];
  result: any;
  formulaList: FormulaList[] = [];
  apiUri: string;
  graphUri: string;
  storageRequired = false;
  lastFormulaVisitedIndex = 0;
  modelTitle = 'Add Formula';
  deletedKpiIds: string[] = [];
  initialAction;
  shortcutKey = '';
  prefixTag = '';
  selectedDataSource: dataSourceModel = new dataSourceModel();
  dataSources = new dataSourceModel();
  expressionItems = {};
  @ViewChild('txtExpression') expressionElement: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<CreateFormulaModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FBDialogData,
    public globals: Globals,
    public globalService: GlobalService, 
    private readonly kpiFormulaService: KPIFormulaBuilderService,
    private readonly http: HttpClient,
    private readonly httpService: HttpService,
    private readonly cd: ChangeDetectorRef
  ) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
    this.formulaBuilderForm.controls['uom'].disable();
    this.uomTypes = Object.keys(UOMData);
    this.uomMap = Object.keys(UOMData).map(key => ({ type: key, value: UOMData[key] }));
  }

  ngOnInit(): void {
    this.isLoader = true;
    if (this.data.UsedFor === 'edit' || this.data.UsedFor === 'view') {
      this.initialAction = 'edit';
      this.preprocessingForEdit();
      this.modelTitle = 'Edit Formula -  ' + this.formulaList[this.formulaList.length - 1].formulaName;
      if (this.data.UsedFor === 'view') {
        this.initialAction = 'view';
        this.modelTitle = 'View Formula -  ' + this.formulaList[this.formulaList.length - 1].formulaName;
        this.formulaBuilderForm.disable();
        this.isLoader = false;
      }
    } else {
      this.addNewFormula('create');
    }
    if (this.data.UsedFor === 'edit' || this.data.UsedFor === 'create') {
      this.getDataSource();
      this.getMathFunctions();
      this.getFormulas();
      this.getConstants();
      this.isLoader = false;
    }
    this.formulaBuilderForm.controls['dataSource'].valueChanges.subscribe(data => {
      if (data !== null || data !== '') {
        this.selectedDataSource = data;
      }
    });
    this.resetExpressionData();
  }

  checkShortcut(event) {    
    const keypress = event.key;
    switch (keypress) {
      case '@': {
        this.shortcutKey = '@';
        prefixTag = this.selectedDataSource.name + '_';
        tagNames = this.selectedDataSource.tags;
        this.setExpressionData('@', tagNames);
        break;
      }
      case '#': {
        this.shortcutKey = '#';
        prefixTag = '';
        tagNames = this.constants;
        this.setExpressionData('#', tagNames);
        break;
      }
      case '$': {
        this.shortcutKey = '$';
        prefixTag = '';
        tagNames = this.existingFormulae;
        this.setExpressionData('$', tagNames);
        break;
      }
      case '~': {
        this.shortcutKey = '~';
        prefixTag = '';
        tagNames = this.mathFunctions;
        this.setExpressionData('~', tagNames);
        break;
      }
    }
  }

  setExpressionData(keyName, keyData){
    this.expressionItems = {
      mentions: [
        {
          triggerChar: keyName,
          items: keyData,
          mentionSelect: (e: any) => {
            if(keyName == '@'){
              return this.selectedDataSource.name + '_' + e.label + " ";
            }
            else{
              return  e.label + " ";
            }
            
          },
        }]
    };
  }

  resetExpressionData(){
    this.expressionItems = {
      mentions: [
        {
          items: [],
          triggerChar: '@',
          mentionSelect: (e: any) => {
            return '';
          }
        },
        {
          items: [],
          triggerChar: '#',
          mentionSelect: (e: any) => {
            return '';
          }
        },
        {
          items: [],
          triggerChar: '$',
          mentionSelect: (e: any) => {
            return '';
          }
        },
        {
          items: [],
          triggerChar: '~',
          mentionSelect: (e: any) => {
            return '';
          }
        }
      ]
    };
  }

  itemSelected(event: any) {
    this.expressionElement.nativeElement.focus();
    this.resetExpressionData();
  }

  findChoices(searchText: string) {
    return tagNames.filter(item =>
      item.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  /**
   * does preprocessing for edit/view data and maps data to formcontrols
   */
  preprocessingForEdit() {
    this.formulaList = [...this.data.FormulaList].reverse();
    this.lastFormulaVisitedIndex = this.formulaList.length - 1;
    const lastFormula = this.formulaList[this.lastFormulaVisitedIndex];
    this.formulaBuilderForm.controls['frequencyHcf'].setValue(lastFormula.frequency);
    const uomrequired = this.uomMap.filter(function (elem) {
      return elem.value.includes(lastFormula.targetUom);
    });
    if (uomrequired[0]) {
      this.formulaBuilderForm.controls['uomType'].setValue(uomrequired[0].type);
    }
    this.populateUOM();
    this.formulaBuilderForm.controls['uom'].setValue(lastFormula.targetUom);
    this.formulaBuilderForm.controls['formulaName'].setValue(lastFormula.formulaName);
    this.formulaBuilderForm.controls['formulaExpression'].setValue(lastFormula.userExpression);
    this.formulaBuilderForm.controls['siConversionIgnored'].setValue(lastFormula.ignoreSi);
  }

  /**
   * Calls API to get process names from backend api.
   */
  getDataSource() {
    this.isLoader = true;
    this.kpiFormulaService.getProcessNames().subscribe((data: dataSourceModel) => {
      this.dataSources = data;
      this.formulaBuilderForm.controls['dataSource'].setValue(this.dataSources[0], { onlySelf: true });
    }, (error) => {
      this.isLoader = false;
      console.log(error);
    });
  }

  /**
   * Calls API to get math functions from backend api.
   */
  getMathFunctions() {
    this.kpiFormulaService.getMathFunctions().subscribe((data: string[]) => {
      this.mathFunctions = data;
    }, (error) => {
      this.isLoader = false;
      console.log(error);
    });
  }

  /**
  * Calls API to get formula names from backend api.
  */
  getFormulas() {
    this.kpiFormulaService.getFormulaNames().subscribe((data: any): void => {
      for (let i = 0; i < data.length; i++) {
        this.existingFormulae[i] = data[i].formulaId;
      }
      if (this.data.UsedFor === 'edit') {
        for (let i = 0; i < this.formulaList.length - 1; i++) {
          this.existingFormulae.unshift(this.formulaList[i].formulaName);
        }
      }
    }, (error) => {
      this.isLoader = false;
      console.log(error);
    });
  }


  /**
   * calls API to get constants list
   */
  getConstants() {
    this.kpiFormulaService.getConstantsFormula().subscribe((data: Constant[]) => {
      for (let i = 0; i < data.length; i++) {
        this.constants[i] = data[i].constantId;
      }
    }, (error) => {
      this.isLoader = false;
      console.log(error);
    });
  }

  /**
   * filteres processNames/existingformulae array and shows only those
   * which contains value provided
   * @param value value by which array is to be filtered
   * @param term which term is to be filtered formula/process/constant
   */
  private _filter(value: string, term): string[] {
    const filterValue = value.toLowerCase();
    if (term === 'process') {
      return this.processNames.filter(option => option.toLowerCase().includes(filterValue));
    } else if (term === 'formula') {
      return this.existingFormulae.filter(option => option.toLowerCase().includes(filterValue));
    } else {
      return this.constants.filter(option => option.toLowerCase().includes(filterValue));
    }
  }

  /**
   * appends a formula in formulalist and updates necessary variables
   */
  addNewFormula(callingFor: string) {
    const formula = {
      formulaId: '',
      frequency: 0,
      userExpression: '',
      formulaName: 'undefined *',
      targetUom: '',
      UOM: '',
      createdBy: '',
      lastModifiedBy: '',
      isDisabled: false,
      storageRequired: false,
      isNewlyAddedAtEdit: false,
      ignoreSi: false
    };
    if (callingFor === 'create') {
      this.formulaList.push(formula);
      this.storageRequired = false;
      this.lastFormulaVisitedIndex = this.formulaList.length - 1;
    } else {
      this.saveFormulaNameNExpression(this.formulaList.length - 1);
      const mainFormula = this.formulaList.splice(this.formulaList.length - 1, 1);
      formula.isNewlyAddedAtEdit = true;
      formula.storageRequired = true;
      this.formulaList.push(formula);
      this.formulaList.push(mainFormula[0]);
      this.cd.detectChanges();
      this.highlightCurrentNUpdateFormula(this.formulaList.length - 2);
    }
  }


  /**
   * populate values in second dropdown on selection of value in first
   * @param uomType uomtype selected
   */
  populateUOM() {
    const _self = this;
    _self.result = this.uomMap.filter((u) => {
      if (this.formulaBuilderForm.controls['uomType'].value === u.type) {
        _self.uoms = u.value;
        this.formulaBuilderForm.controls['uom'].enable();
      }
    });
  }

  /**
   * updates data of intermediate formula in formulalist
   */
  saveIntermediate() {
    const index = this.storageRequired ? this.lastFormulaVisitedIndex : this.formulaList.length - 1;
    if (this.formulaBuilderForm.controls['formulaExpression'].value !== ''
      || this.formulaBuilderForm.controls['formulaName'].value !== '') {
      if (this.saveFormulaNameNExpression(index) !== false) {
        this.saveFormulaDetails(index);
        this.formulaList[index].storageRequired = true;
        this.formulaBuilderForm.controls['formulaExpression'].reset('');
        this.formulaBuilderForm.controls['formulaName'].reset('');
        if (!this.storageRequired) {
          this.addNewFormula('create');
        }
      } else {
        return false;
      }
    }
  }

  /**
   * updates provided formula name and expression in formulalist
   * @param index index of formula in formulalist
   */
  saveFormulaNameNExpression(index) {
    const formula = this.formulaList[index];
    formula.userExpression = this.formulaBuilderForm.controls['formulaExpression'].value;
    // checks if current formula name and existing formula name are different
    if (formula.formulaName !== this.formulaBuilderForm.controls['formulaName'].value) {
      // checks if formula with formula name is already there
      // if so, shows alert, resets formula name and returns false
      if (this.formulaList.filter(m => m.formulaName.toLowerCase() ===
        this.formulaBuilderForm.controls['formulaName'].value.toLowerCase()).length > 0) {
        this.globalService.showAlert(AlertComponent,
          {
            success: false,
            message: 'You cannot create formula with duplicate names'
          });
        this.formulaBuilderForm.controls['formulaName'].reset('');
        return false;
      }

      // removes existing name of intermediate formula from dropdown
      if (this.existingFormulae.includes(formula.formulaName)) {
        this.existingFormulae.splice(this.existingFormulae.indexOf(formula.formulaName), 1);
      }

      formula.formulaName = this.formulaBuilderForm.controls['formulaName'].value === '' ? 'undefined *'
        : this.formulaBuilderForm.controls['formulaName'].value;

      // adds updated formuala name in autocomplete
      if (!this.existingFormulae.includes(formula.formulaName)) {
        this.existingFormulae.unshift(formula.formulaName);
      }
    }
  }

  /**
   * updates remaining details of provided formula in formulalist
   * @param index index of formula in formulalist
   */
  saveFormulaDetails(index) {
    const formula = this.formulaList[index];
    formula.lastModifiedBy = this.globalService.loggedInUser;
    formula.UOM = this.formulaBuilderForm.controls['uomType'].value;
    formula.targetUom = this.formulaBuilderForm.controls['uom'].value;
    formula.createdBy = this.data.UsedFor === 'edit' ? formula.createdBy : this.globalService.loggedInUser;
    formula.frequency = this.formulaBuilderForm.controls['frequencyHcf'].value;
    formula.ignoreSi = this.formulaBuilderForm.controls['siConversionIgnored'].value;
  }

  /**
   * used for traversal between 2 formulae
   * @param index index of currently clicked formula in formulalist
   */
  traverseToAnotherFormula(index) {
    if (this.formulaList[this.lastFormulaVisitedIndex].storageRequired) {
      if (this.saveIntermediate() === false) {
        return false;
      }
    }

    this.highlightCurrentNUpdateFormula(index);
  }

  /**
   * Shows confirm popup for confirmation of delete of intermediate formula
   */
  deleteIntermediate() {
    const dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: 'Deleting an intermediate formula would affect the formulas dependent on it. Are you sure you want to delete?'
    };
    this.globalService.openModelWindow(this.deleteIntermediateFormula, this, ConfirmModelComponent,
      '450px', 'confirm-modalbox', dataToPass);
  }

  /**
   * deletes intermediate formula from formulalist and stores kpi id in another string array
   * @param thisRef reference for current component
   */
  deleteIntermediateFormula(thisRef: CreateFormulaModelComponent) {
    if (!thisRef.formulaList[thisRef.lastFormulaVisitedIndex].isNewlyAddedAtEdit) {
      thisRef.deletedKpiIds.push(thisRef.formulaList[thisRef.lastFormulaVisitedIndex].formulaId);
    }
    thisRef.formulaList.splice(thisRef.lastFormulaVisitedIndex, 1);
    thisRef.cd.detectChanges();
    thisRef.highlightCurrentNUpdateFormula(thisRef.lastFormulaVisitedIndex);
  }

  /**
   * highlights currenlty clicked formula and loads values of formulaname
   * and expression in form control and updates storage required field
   * @param index index of currently clicked formula
   */
  highlightCurrentNUpdateFormula(index) {
    const element = document.getElementsByClassName('highlighted')[0];
    if (element) {
      element.classList.remove('highlighted');
    }
    if (document.getElementById('fieldFormula_' + index)) {
      document.getElementById('fieldFormula_' + index).classList.add('highlighted');
    }
    this.storageRequired = this.formulaList[index].storageRequired;
    this.formulaBuilderForm.controls['formulaExpression'].setValue(this.formulaList[index].userExpression);
    this.formulaBuilderForm.controls['formulaName'].setValue(
      this.formulaList[index].formulaName === 'undefined *' ? '' : this.formulaList[index].formulaName);
    this.lastFormulaVisitedIndex = index;
    if (this.initialAction === 'edit') {
      if (this.formulaList[index].isNewlyAddedAtEdit) {
        this.data.UsedFor = 'create';
      } else {
        this.data.UsedFor = 'edit';
      }
    }
  }

  /**
   * final save call which calls backend api and saves formula
   */
  SaveFormula() {
    this.saveFormulaNameNExpression(this.lastFormulaVisitedIndex);

    for (let index = 0; index < this.formulaList.length; index++) {
      this.saveFormulaDetails(index);
    }
    this.isLoader = true;
    this.kpiFormulaService.saveFinalFormula(this.deletedKpiIds, this.formulaList).subscribe((result: any): void => {
        this.isLoader = false;
        if (result.m_StringValue === 'Success') {
          this.dialogRef.close('Success');
        } else {
          this.globalService.showAlert(AlertComponent, { success: false, message: result.m_StringValue });
        }
      }, (error) => {
        this.isLoader = false;
        console.log(error);
      });
  }

  /**
  * get call on click of cancle button on update dialog box
  * closes dialog box with result as 'Cancel'
  */
  onCancelClick(): void {
    this.dialogRef.close('Cancel');
  }

}
